/**
 * Serialización SEGURA de JSON-LD.
 *
 * `JSON.stringify` escapa comillas, pero NO escapa `<`. Dentro de un `<script>` eso importa:
 * el parser de HTML corta el bloque en la primera secuencia `</script`, venga de donde venga.
 * Y acá viene de la base — la `description` de un curso es rich text cargado desde el admin.
 * Un `</script>` ahí adentro (o un `<!--`) parte el JSON-LD al medio, y todo lo que sigue en
 * el documento se interpreta como HTML suelto.
 *
 * Mientras esto vivía sólo en el cliente el riesgo era menor: React inyectaba el nodo ya
 * parseado. Desde que las landings se renderizan en el SERVIDOR, este string viaja crudo
 * dentro del HTML y lo parsea el browser, así que el escape pasa a ser obligatorio.
 *
 * U+2028 y U+2029 van aparte: son saltos de línea válidos dentro de un string JSON pero
 * ilegales dentro de un literal de JavaScript, así que rompen a cualquier consumidor que
 * evalúe el bloque en vez de parsearlo.
 */
function serializeJsonLd(data: object): string {
  return JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

export function JsonLd({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
    />
  );
}
